import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import axios from "axios";
import toast from "react-hot-toast";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  // pt: 2,
  // px: 4,
  // pb: 3,
  p: 2,
};



function EditOc({ open, handleClose, inventoryId, setLoading, getData, selectedQualityParameter }) {


  const handleSubmit = async(values) => {
   
    const payload = {
      current_qp: [{
        fm: values?.fm || null,
        hm: values?.hm || null,
        odour: values?.odour || null,
        gluten: values?.gluten || null,
        shruken: values?.shruken || null,
        variety: values?.variety || null,
        hardness: values?.hardness || null,
        moisture: values?.moisture || null,
        shrivelled: values?.shrivelled || null,
        grain_width: values?.grain_width || null,
        kernel_size: values?.kernel_size || null,
        oil_content: values?.oil_content || null,
        grain_colour: values?.grain_color || null,
        grain_length: values?.grain_length || null,
        other_grains: values?.other_grains || null,
        broken_grains: values?.broken_grains || null,
        insects_fungi: values?.insects_fungi || null,
        damaged_grains: values?.damaged_grains || null,
        starch_content: values?.starch_content || null,
        falling_numbers: values?.falling_numbers || null,
        grain_thickness: values?.grain_thickness || null,
        protein_content: values?.protein_content || null,
        discoloured_grains: values?.discolored_grains || null
      }],
      
    }


    const url = `/api/oms/${inventoryId}`

    
    try {
      setLoading(true);
      const {data} = await axios.patch(url, payload);
      if(data.status){
        formik.resetForm();
        
        
        setLoading(false);
        toast.success(data.message);
        getData();
        handleClose();
      }
      else{
        setLoading(false);
        toast.error(data.message);
      }

    } catch (error) {
      console.log(error);
      toast.error(error.response ? error.response.message : "Error Occured");
    }
    
  }

  const initialValues = {
    damaged_grains: null,
    broken_grains: null,
    discolored_grains: null,
    falling_numbers: null,
    fm: null,
    gluten: null,
    grain_color: null,
    grain_length: null,
    grain_thickness: null,
    grain_width: null,
    hardness: null,
    hm: null,
    insects_fungi: null,
    kernel_size: null,
    moisture: null,
    odour: null,
    oil_content: null,
    other_grains: null,
    protein_content: null,
    shrivelled: null,
    shruken: null,
    starch_content: null,
    variety: null
  }

  const formik = useFormik({
    initialValues: initialValues,
    // validate,
    onSubmit: handleSubmit,
  });

  
  console.log(selectedQualityParameter);


  useEffect(() => {

    formik.setValues({
      ...formik.values,
      damaged_grains: selectedQualityParameter?.damaged_grains,
      broken_grains: selectedQualityParameter?.broken_grains,
      discolored_grains: selectedQualityParameter?.discoloured_grains,
      falling_numbers: selectedQualityParameter?.falling_numbers,
      fm: selectedQualityParameter?.fm,
      gluten: selectedQualityParameter?.gluten,
      grain_color: selectedQualityParameter?.grain_colour,
      grain_length: selectedQualityParameter?.grain_length,
      grain_thickness: selectedQualityParameter?.grain_thickness,
      grain_width: selectedQualityParameter?.grain_width,
      hardness: selectedQualityParameter?.hardness,
      hm: selectedQualityParameter?.hm,
      insects_fungi: selectedQualityParameter?.insects_fungi,
      kernel_size: selectedQualityParameter?.kernel_size,
      moisture: selectedQualityParameter?.moisture,
      odour: selectedQualityParameter?.odour,
      oil_content: selectedQualityParameter?.oil_content,
      other_grains: selectedQualityParameter?.other_grains,
      protein_content: selectedQualityParameter?.protein_content,
      shrivelled: selectedQualityParameter?.shrivelled,
      shruken: selectedQualityParameter?.shruken,
      starch_content: selectedQualityParameter?.starch_content,
      variety: selectedQualityParameter?.variety
    });

  }, [selectedQualityParameter])

  


  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <h5 id="child-modal-title">Update Quality Parameters </h5>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
          <form onSubmit={formik.handleSubmit}>
            <div className="grid grid-cols-3">
              <div className="mb-2">
                <TextField 
                  label="Damaged Grains:" 
                  name="damaged_grains"
                  onChange={formik.handleChange}
                  value={formik.values.damaged_grains}
                  />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Broken Grains:"
                  name="broken_grains" 
                  onChange={formik.handleChange}
                  value={formik.values.broken_grains}
                  />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Discolored Grains:" 
                  name="discolored_grains" 
                  onChange={formik.handleChange} 
                  value={formik.values.discolored_grains}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Falling Numbers:" 
                  name="falling_numbers"
                  onChange={formik.handleChange}
                  value={formik.values.falling_numbers}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="FM:" 
                  name="fm"
                  onChange={formik.handleChange}
                  value={formik.values.fm}
                  />
              </div>
              <div className="mb-2">
                <TextField 
                label="Gluten:" 
                name="gluten"
                onChange={formik.handleChange}
                value={formik.values.gluten}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Grain Color:" 
                  name="grain_color"
                  onChange={formik.handleChange}
                  value={formik.values.grain_color}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Grain Length:" 
                  name="grain_length"
                  onChange={formik.handleChange}
                  value={formik.values.grain_length}
                  />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Grain Thickness:" 
                  name="grain_thickness"  
                  onChange={formik.handleChange}
                  value={formik.values.grain_thickness}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Grain Width:"
                  name="grain_width"
                  onChange={formik.handleChange}
                  value={formik.values.grain_width}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Hardness:" 
                  name="hardness"
                  onChange={formik.handleChange}
                  value={formik.values.hardness}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="HM:" 
                  name="hm"
                  onChange={formik.handleChange}
                  value={formik.values.hm}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Insects Fungi:" 
                  name="insects_fungi"
                  onChange={formik.handleChange}
                  value={formik.values.insects_fungi}
                  />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Kernel Size:" 
                  name="kernel_size"
                  onChange={formik.handleChange}
                  value={formik.values.kernel_size}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Moisture:" 
                  name="moisture"
                  onChange={formik.handleChange}
                  value={formik.values.moisture}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Odour:" 
                  name="odour"
                  onChange={formik.handleChange}
                  value={formik.values.odour}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Oil Content:" 
                  name="oil_content"
                  onChange={formik.handleChange}
                  value={formik.values.oil_content}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Other Grains:" 
                  name="other_grains"
                  onChange={formik.handleChange}
                  value={formik.values.other_grains}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Protein Content:" 
                  name="protein_content"
                  onChange={formik.handleChange}
                  value={formik.values.protein_content}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Shrivelled:" 
                  name="shrivelled"
                  onChange={formik.handleChange}
                  value={formik.values.shrivelled}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Shruken:" 
                  name="shruken"
                  onChange={formik.handleChange}
                  value={formik.values.shruken}
                />
              </div>
              <div className="mb-2">
                <TextField 
                
                  label="Starch Content:" 
                  name="starch_content"
                  onChange={formik.handleChange}
                  value={formik.values.starch_content}
                />
              </div>
              <div className="mb-2">
                <TextField 
                  label="Variety:" 
                  name="variety"
                  onChange={formik.handleChange}
                  value={formik.values.variety}
                />
              </div>



              

              
            </div>

            <div className="mt-3 flex text-center justify-center">
              <Button
                
                type="submit"
                variant="contained"
                className="me-3"
                style={{ backgroundColor: "#131542" }}
              >
                Update
              </Button>
              <Button
                variant="contained"
                type="button"
                style={{ backgroundColor: "#C7081E" }}
                onClick={() => handleClose()}
              >
                Close
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
}

export default EditOc;
